module.exports = __webpack_public_path__ + "static/media/astronauta_listo.e51f5705.svg";